/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import {
  canShowRangeSwitch,
  flipRange,
  onFetchOdo,
  changeVehicle,
  before_buffer,
  after_buffer,
} from "./historyReport/historyReport";
import {
  bulkReqTracker,
  indianNumberFormat,
  stripLoc,
} from "../../../helpers/helperFunctions";
import _ from "lodash";
import moment from "moment";
// import mixpanel from "mixpanel-browser";

let _dateFormat = dateFormat + ":ss";

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  let locationbody = [];

  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    let model = vehicleMap[vehiclepath].vehicleModel
      ? vehicleMap[vehiclepath].vehicleModel.model
      : vehicleMap[vehiclepath].vehiclemeta
      ? vehicleMap[vehiclepath].vehiclemeta.model || ""
      : "";

    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null ? new Date(eachitem.starttime) : null;
      let endtime =
        eachitem.endtime != null ? new Date(eachitem.endtime) : null;
      let location = eachitem.lat + "," + eachitem.lng;
      let latLngArr = [eachitem.lat, eachitem.lng];
      let fuelfilled = eachitem.refuelLitres;
      let tankid = eachitem.tankid;
      let fuelprice = indianNumberFormat((eachitem.fuelprice || 0).toFixed(2));
      locationbody.push([eachitem.lat, eachitem.lng]);
      historyData.push({
        vehicleno,
        model,
        starttime,
        endtime,
        fuelfilled,
        location,
        latLngArr,
        vehiclepath,
        tankid,
        fuelprice,
      });
    }
  }

  callback(historyData);
  // GeoCodeAPIs.getAddress(locationbody).then(
  //   (resp) => {
  //     for (let idx in historyData) {
  //       historyData[idx].location = resp[idx][1];
  //     }
  //     callback(historyData);
  //   },
  //   (resp) => {
  //     console.log(resp);
  //   }
  // );
};

const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Refuel Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  clear();
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  if (starttime > endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, (data) => {
        schema.finalData = data;
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          schema.content[0].ref.setData(data);
        }
      });
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      vehicleid: data.vehicle.map((item) => {
        return item.data.vehicleid;
      }),
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    ReportAPIs.getRefuelHistoryList(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    window.graphDataErr = "";

    console.log("inside else");
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    // window.dispatchStoreEvent({
    //   type: actions.GRAPHSET_STATE_CHANGED,
    //   data: 0,
    // });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const getShapes = () => {
  let refuelPoints = [];
  for (let idx in schema.refuelHistory) {
    let refule = schema.refuelHistory[idx];
    let startindex = _.sortedIndexBy(
      schema.refuelHistory,
      { time: refule.starttime },
      "time"
    );
    let endindex = _.sortedIndexBy(
      schema.refuelHistory,
      { time: refule.endtime },
      "time"
    );
    refuelPoints.push(schema.refuelHistory.slice(startindex, endindex));
  }
  return refuelPoints.map((r) => ({
    strokeOpacity: 1,
    stroke: "#0f0",
    axis: 0,
    type: "path",
    data: r,
  }));
};

const onItemClick = (reportItem) => {
  let oneHour = 1000 * 60 * 60;
  let endtime = reportItem.endtime.getTime() + oneHour;
  let starttime = reportItem.starttime.getTime() - oneHour;
  let body = {
    vehicleid: [parseInt(reportItem.vehiclepath, 10)],
    endtime,
    starttime,
  };

  schema.selectedVehicle = window.selectedVehicles.filter(
    (d) => d.name === reportItem.vehicleno
  )[0];

  let apis = [
    { api: ReportAPIs.getFuelLevelInfo, body, key: "fuellevel" },
    { api: ReportAPIs.getRefuelHistory, body, key: "refuel" },
  ];

  const handleResponse = (resp) => {
    schema.refuelHistory = resp[0].resp;
    schema.refuelHistory = resp[1].resp[Object.keys(resp[1].resp)[0]];

    if (!Array.isArray(schema.refuelHistory) && reportItem.tankid) {
      schema.refuelHistory = schema.refuelHistory[reportItem.tankid];
    }
    if (!Array.isArray(schema.refuelHistory) && reportItem.tankid) {
      schema.refuelHistory = schema.refuelHistory[reportItem.tankid];
    }
    schema.refuelHistory.forEach((f) => {
      let before = before_buffer(f, schema.refuelHistory);
      if (before.time) f.starttime = before.time;
      let after = after_buffer(f, schema.refuelHistory);
      if (after.time) f.endtime = after.time;
    });
    schema.content[1].ref.draw(
      {
        data: [schema.refuelHistory],
        axis: 0,
        reqTime: Date.now(),
        priority: Date.now(),
      },
      {
        xDomainValue: [starttime, endtime],
        shapes: getShapes(),
      }
    );
  };

  bulkReqTracker(apis, handleResponse);
};

const getFuelValue = (value) => {
  let tankCapacity = _.get(schema.selectedVehicle, "data.fueltankcapacity");
  if (_.get(schema.selectedVehicle, "data.vehicleModel.fueltype") === "EV") {
    tankCapacity = tankCapacity ? tankCapacity : 100;
  }
  tankCapacity = parseInt(tankCapacity);
  return (
    value + "%, " + parseFloat((value / 100) * tankCapacity).toFixed(1) + " L"
  );
};

const tankColumnShowable = (vh) => {
  let check = (v) => _.get(v, "data.vehiclemeta.numfueltanks", 1) > 1;
  return Array.isArray(vh) ? vh.map(check).includes(true) : check(vh);
};

const download = (schema, data, store) => {
  // mixpanel.track("User Downloads Refuel Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0; // kushalsslp
  if (schema.finalData) {
    let finalData = _.map(schema.finalData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      if (strictColumns) {
        r.location = stripLoc(r.location);
      }
      return r;
    });
    if (strictColumns) {
      finalData = _.map(finalData, (r) => {
        let headings = schema.content[0].head
          .filter((c) => (c.isShowable ? c.isShowable(data.vehicle) : true))
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }
    JSONToCSVConvertor(finalData, "RefuelReport", false);
  }
};

const schema = {
  key: "refuel_report",
  name: "Refuel Report",
  finalData:null,
  refuelHistory:[],
  fuelLevelHistory:[],
  selectedVehicle:null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get refuel Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 7,
        left: 0,
        top: 0,
      },
      onItemClick,
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        { key: "model", name: "", name: "Model" },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: _dateFormat,
        },
        { key: "endtime", name: "End Time", type: "DATE", format: _dateFormat },
        { key: "tankid", name: "Tank ID", isShowable: tankColumnShowable },
        { key: "fuelfilled", name: "Fuel Filled (ltr)" },
        { key: "fuelprice", name: "Fuel price (₹)" },
        {
          key: "location",
          name: "Location",
          width: 3,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.latLngArr[0], item.latLngArr[1]);
          },
        },
      ],
    },
    {
      key: "fuellevelpilferage",
      type: schemaTypes.IN_GRAPH,
      graphType: "graph",
      position: {
        width: 12,
        height: 5,
        left: 0,
        top: 7,
      },
      showTime: true,
      graphSetName: "refuleGraph",
      background: "#333",
      depAPIs: ["pilferageReport", "getRefuelHistory"],
      config: [
        {
          listenTo: [{ api: "getFuelLevelInfo", key: "value" }],
          color: "#fff",
          name: "Fuel ",
          getValue: getFuelValue,
          unit: "%",
        },
      ],
    },
  ],
};

export default schema;

const clear = () => {
  if (schema.content[1].ref) {
    schema.content[1].ref.draw(
      {
        data: [],
        axis: 0,
        reqTime: Date.now(),
        priority: Date.now(),
      },
      {
        xDomainValue: [0, 0],
        shapes: [],
      }
    );
  }
};

window.refreshRefuelGraph = () => {
  setTimeout(clear, 50);
  setTimeout(clear, 500);
};
